
import { carrieBio, mirandaBio, samanthaBio } from './charlotteBios'
import { carrieReviewerReviewHinge, mirandaReviewerReviewBumble, samanthaReviewerReviewTinder } from './charlotteReviewerReviews'

export const carrieReviewerProfile = {
  _id: 'carrieReviewerProfileId',
  userId: 'carrieUserId',
  email: 'carrie@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-5.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...carrieBio },
  profileReviews: [
    // { ...carrieProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...carrieReviewerReviewHinge }
  ],
}

export const mirandaReviewerProfile = {
  _id: 'mirandaReviewerProfileId',
  userId: 'mirandaUserId',
  email: 'miranda@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-miranda-13-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...mirandaBio },
  profileReviews: [
    // { ...mirandaProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...mirandaReviewerReviewBumble }
  ],
}

export const samanthaReviewerProfile = {
  _id: 'samanthaReviewerProfileId',
  userId: 'samanthaUserId',
  email: 'samantha@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-samantha-5-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...samanthaBio },
  profileReviews: [
    // { ...samanthaProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...samanthaReviewerReviewTinder }
  ],
}